// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { Box, Stack } from "@mui/material";
import logoUSAID from "assets/images/USAID_Horiz_Spanish_CMYK_2-Color-01.png";
import logoUGB from "assets/images/logo-ugb-horizontal.png";

function DefaultFooter({ content }) {
  const { socials, menus, copyright } = content;

  return (
    <>
      <MKBox px={1} style={{ backgroundColor: "#F0F2F5", width: "100%" }} py={6}>
        <MKBox component="footer">
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3} sx={{ ml: "auto" }}>
                <MKTypography variant="h2" fontWeight="bold" sx={{ color: "#344767" }}>
                  Centro Histórico
                </MKTypography>
                <MKTypography variant="h3" sx={{ color: "#858AA2" }}>
                  San Miguel
                </MKTypography>
                <MKBox display="flex" alignItems="center" mt={1}>
                  {socials.map(({ icon, link }, key) => (
                    <MKTypography
                      key={link}
                      component="a"
                      href={link}
                      target="_blank"
                      rel="noreferrer"
                      variant="h4"
                      mr={key === socials.length - 1 ? 0 : 2.5}
                      style={{ color: "#5A6983" }}
                    >
                      {icon}
                    </MKTypography>
                  ))}
                </MKBox>
              </Grid>
              {menus.map(({ name: title, items }) => (
                <Grid key={title} item xs={6} md={2} sx={{ mb: 3 }}>
                  <MKTypography
                    display="block"
                    variant="body2"
                    fontWeight="bold"
                    mb={1}
                    style={{ color: "#5A6983" }}
                  >
                    {title}
                  </MKTypography>
                  <MKBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
                    {items.map(({ name, route, href }) => (
                      <MKBox key={name} component="li" p={0} m={0} lineHeight={1.25}>
                        {href ? (
                          <MKTypography
                            component="a"
                            href={href}
                            target="_blank"
                            rel="noreferrer"
                            variant="button"
                            fontWeight="regular"
                            style={{ color: "#51627D" }}
                          >
                            {name}
                          </MKTypography>
                        ) : (
                          <MKTypography
                            component={Link}
                            to={route}
                            variant="button"
                            fontWeight="regular"
                            style={{ color: "#51627D" }}
                          >
                            {name}
                          </MKTypography>
                        )}
                      </MKBox>
                    ))}
                  </MKBox>
                </Grid>
              ))}
            </Grid>
            <Grid container>
              <Grid item xs={9} md={3} ml={6} lg={12}>
                <Box m={4}>
                  <Stack direction="row" justifyContent="left" style={{ overflowX: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        height: "10px",
                      }}
                    >
                      <tr>
                        <td
                          style={{
                            textAlign: "right",
                            width: "4%",
                            whiteSpace: "nowrap",
                            height: "30px",
                            paddingTop: "0px",
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            paddingBottom: "0px",
                            border: "none",
                          }}
                        >
                          <img src={logoUSAID} alt="USAID" width={210} />
                        </td>
                        <td
                          style={{
                            textAlign: "left",
                            width: "4%",
                            whiteSpace: "nowrap",
                            border: "none",
                            height: "30px",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <img src={logoUGB} alt="UGB" width={170} />
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={3}
                          style={{
                            border: "none",
                            width: "10%",
                            textAlign: "center",
                            paddingTop: "0px",
                          }}
                        >
                          <MKTypography
                            variant="body2"
                            color="text"
                            style={{ fontSize: "15px", textAlign: "justify" }}
                          >
                            <br />
                            <br />
                            La información generada bajo la iniciativa{" "}
                            <b>
                              “Revitalización del Centro Histórico de San Miguel a través de
                              Herramientas Tecnológicas”
                            </b>{" "}
                            es posible gracias al apoyo del Pueblo de los Estados Unidos de América,
                            a través de la Agencia de los Estados Unidos para el Desarrollo
                            Internacional (USAID). Los contenidos (audiovisuales y editoriales), la
                            exposición de las publicaciones, la coordinación del proceso y toda la
                            gestión administrativa de esta plataforma en línea son responsabilidad
                            exclusiva de la Universidad Gerardo Barrios (UGB) y no reflejan
                            necesariamente los puntos de vista de USAID o del Gobierno de los
                            Estados Unidos.
                            <br />
                            <br />
                            USAID, a través del Proyecto de USAID Gobernabilidad Municipal, es un
                            aliado estratégico de la UGB en el impulso de la revitalización del
                            Centro Histórico de San Miguel.
                          </MKTypography>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            textAlign: "center",
                            paddingTop: "0px",
                            border: "none",
                          }}
                          colSpan={3}
                        >
                          <br />
                          <br />
                          {copyright}
                        </td>
                      </tr>
                    </table>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </MKBox>
    </>
  );
}

// Typechecking props for the DefaultFooter
DefaultFooter.propTypes = {
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array])).isRequired,
};

export default DefaultFooter;
